import { T } from '@tribeplatform/react-components/i18n'
import { SlateRenderer } from '@tribeplatform/react-slate-kit/components'
import type { SlateProps } from '@tribeplatform/react-slate-kit/types'
import { Container } from '@tribeplatform/react-ui-kit/Layout'
import { LoadingOverlay } from '@tribeplatform/react-ui-kit/LoadingOverlay'

import type { CustomizerPreviewMode } from '../hooks/use-customizer-navigation.hook.js'
import { useCustomizerTemplate } from '../hooks/useCustomizerTemplate.js'
import SampleContent from '../sample-components/SampleContent.js'

interface PreviewIFrameProps {
  previewMode: CustomizerPreviewMode
  slateProps: SlateProps
}
export const PreviewContent = ({
  previewMode,
  slateProps,
}: PreviewIFrameProps) => {
  const { previewHtml } = useCustomizerTemplate()

  switch (previewMode) {
    case 'navigation':
    case 'logos':
      return (
        <Container size="full" padding={{ top: 'md' }}>
          <div className="flex h-96 w-full border-2 border-dashed border-line">
            <span className="m-auto">
              <T defaultMessage="Page Content" id="Admin.Editor.PageContent" />
            </span>
          </div>
        </Container>
      )
    case 'appearance':
      return <SampleContent />
    case 'slate':
    case 'post-types':
      return <SlateRenderer {...slateProps} />
    case 'template':
      return (
        <LoadingOverlay isLoading pulse={false} opaque={false}>
          {previewHtml ? (
            <div
              className="flex flex-col"
              // We have to inject html to preview the templates
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: previewHtml }}
            ></div>
          ) : (
            <SlateRenderer {...slateProps} />
          )}
        </LoadingOverlay>
      )
    default:
      return null
  }
}
